module.exports = __webpack_public_path__ + "img/lib_region_flag_gy.9def194e.png";